import * as actions from './action';

const init = {
  goal: null,
  activeStep: 1,
  creativeActiveStep: 1,
  monitorActivityActiveStep: 1,
  inputs: {
    campaigns: [],
    adgroups: [],
    products: [],
    productSkus: [],
    creatives: [],
    loading: true,
  },
  config: {
    selectedInputType: '',
    campaigns: [],
    adgroups: [],
    productSkus: [],
    products: [],
    creatives: '',
    selectedKeywordsByUser: [],
  },
};

export default (state = init, action) => {
  const newState = { ...state };

  switch (action.type) {
    case actions.MICRO_GOALS_LAUNCH_SET_STEP:
      newState.activeStep = action.payload;
      break;

    case actions.CREATIVE_SET_ACTIVE_STEP:
      newState.creativeActiveStep = action.payload;
      break;

    case actions.MONITOR_ACTIVITY_SET_ACTIVE_STEP:
      newState.monitorActivityActiveStep = action.payload;
      break;

    case actions.MICRO_GOALS_SET_GOAL_DATA:
      /* eslint-disable  no-case-declarations */
      const goal = action.payload;
      newState.goal = goal;

      // Add all required goal inputs as null.
      const goalInputs = {};
      /* eslint-enable  no-case-declarations */
      if (goal.config) {
        Object.keys(goal.config).map((config) => {
          goalInputs[config] = null;
        });
      }

      newState.config = { ...init.config };
      break;

    case actions.MICRO_GOALS_SET_INPUT_DATA:
      newState.inputs = { ...state.inputs };
      newState.inputs[action.name] = action.payload;
      newState.inputs.loading = false;
      break;

    case actions.MICRO_GOALS_PUSH_CONFIG:
      newState.config = { ...state.config };

      // If the config has multiple items, iterate and push.
      if (typeof newState.config[action.name] === 'object' && newState.config[action.name] !== null) {
        newState.config[action.name] = [...newState.config[action.name]];
        newState.config[action.name].push(action.payload);
      } else {
        // If the config has single items (string), update it.
        newState.config[action.name] = action.payload;
      }

      break;

    case actions.MICRO_GOALS_POP_CONFIG:
      newState.config = { ...state.config };
      newState.config[action.name] = newState.config[action.name].filter((i) => i !== action.payload);
      break;

    case actions.MICRO_GOALS_DELETE_CONFIG:
      newState.config = { ...state.config };
      delete newState.config[action.name];
      break;

    case actions.UPDATE_GOAL_CONFIGS:
      newState.config = { ...newState.config, ...action.payload };
      break;

    case actions.MICRO_GOALS_RESET_CONFIG:
      newState.config = { ...state.config };
      newState.config[action.name] = action.payload;
      break;

    case actions.MICRO_GOALS_REPLACE_CONFIG:
      newState.config = { ...state.config };
      // If the config is array|object
      if (Array.isArray(newState.config[action.name])) {
        newState.config[action.name] = [action.payload];
      } else {
        // If the config anything else except array|object
        newState.config[action.name] = action.payload;
      }
      break;

    default:
  }
  return newState;
};
